import React, { useState } from "react";
import logo from './../logo.png';
import ReCAPTCHA from "react-google-recaptcha";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import 'primeicons/primeicons.css';
import Alertas from "./../alertas";
import api from "./../api";
import { chaveRecaptcha } from "./../captcha";

function FormBaixoAm() {

  const [nome, setNome] = useState("");
  const [nomeSocial, setNomeSocial] = useState("");
  const [dataNasc, setDataNasc] = useState("");
  const [rg, setRg] = useState("");
  const [cpf, setCpf] = useState("");

  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [endereco, setEndereco] = useState("");

  const [pcd, setPcd] = useState(false);
  const [apoioEsp, setApoioEsp] = useState(false);
  const [tipoApoio, setTipoApoio] = useState("");

  const [file_rg_cpf, setFile_rg_cpf] = useState(null);
  const [file_cr, setFile_cr] = useState(null);
  const [file_decl_pessoal, setFile_decl_pessoal] = useState(null);
  const [file_autodeclaracao, setFile_autodeclaracao] = useState(null);

  const [recaptcha, setRecaptcha] = useState(null);
  const [load, setLoad] = useState(false);

  // Retirar Log do captchar após configuração
  function captcharFunction(r) {
    setRecaptcha(r);
  }

  function expira_captcha() {
    setRecaptcha(null);
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    }
  };

  function limpar() {
    setNome("");
    setNomeSocial("");
    setDataNasc("");

    setCpf("");
    setRg("");

    setEndereco("");
    setTelefone("");
    setEmail("");

    setPcd(false);
    setApoioEsp(false);
    setTipoApoio(false);

    setFile_rg_cpf(null);
    setFile_cr(null);
    setFile_decl_pessoal(null);
    setFile_autodeclaracao(null);
  }

  function enviar_email() {
    if (nome && dataNasc && rg && cpf &&
      endereco && telefone && email &&
      file_rg_cpf && file_cr && file_decl_pessoal ) {
      setLoad(true);

      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("nome_social", nomeSocial);
      formData.append("data_nascimento", dataNasc);

      formData.append("rg", rg);
      formData.append("cpf", cpf);

      formData.append("endereco", endereco);
      formData.append("telefone", telefone);
      formData.append("email", email);

      formData.append("pcd", `${pcd ? "Sim" : "Não"}`);
      formData.append("apoio_especial", `${apoioEsp ? "Sim" : "Não"}`);
      formData.append("tipo_apoio", `${tipoApoio ? tipoApoio : "-"}`);

      formData.append("attachment_0", file_rg_cpf);
      formData.append("attachment_1", file_cr);
      formData.append("attachment_2", file_decl_pessoal);
      formData.append("attachment_3", file_autodeclaracao);
      formData.append("recaptcha", recaptcha);


      api.post('/email_bx_amazonas/', formData, config)
        .then((res) => {
          if (res.data == 200) {
            setLoad(false);
            limpar();
            Alertas.sucesso("Dados enviados");
          } else {
            setLoad(false);
            if (!recaptcha) {
              Alertas.erro("Faça a verificação reCAPTCHA");
            } else {
              Alertas.erro("Erro ao enviar formulário");
            }
          }
        }).catch((err) => {
          setLoad(false);
          Alertas.erro(err);
        })
    } else {
      Alertas.toast_cuidado("Preencha os campos obrigatórios")
    }
  }

  function changeFiles(file, tipo) {

    const maxSize = 3 * 1024 * 1024; // 3 MB em bytes

    if (file.size > maxSize) {
      Alertas.atencao('Tamanho não permitido. Por favor escolha um arquivo de no máximo 3 MB.');
    } else {
      switch (tipo) {
        case 1:
          setFile_rg_cpf(file);
          break;
        case 3:
          setFile_cr(file);
          break;
        case 4:
          setFile_decl_pessoal(file);
          break;
        case 5:
          setFile_autodeclaracao(file);
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className="App">
      <Dialog
        visible={load}
        style={{ width: '70vw' }}
        closable={false}
        closeOnEscape={false}
        draggable={false}
      >
        <div className="load-spinner">
          <ProgressSpinner />
          <p>Preparando dados para o envio</p>
        </div>
      </Dialog>

      <div className="app-nav">
        <img src={logo} className="nav-logo" alt="logo-dpe" />
        <p className="card-texto">
          PS de Residência Polo do Baixo Amazonas 2024.1
        </p>
      </div>
      <div className="app-main">
        <div className="main-card">

          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Nome Completo*</p>
              <InputText value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="card-form-a">
              <p className="labels">Nome Social</p>
              <InputText value={nomeSocial} onChange={(e) => setNomeSocial(e.target.value)} />
            </div>

          </div>

          <div className="card-form">
            <div className="card-form-b">
              <p className="labels">Data de Nascimento *</p>
              <InputMask mask="99/99/9999" value={dataNasc} onChange={(e) => setDataNasc(e.target.value)} />
            </div>
            <div className="card-form-b">
              <p className="labels">RG *</p>
              <InputText value={rg} onChange={(e) => setRg(e.target.value)} />
            </div>
            <div className="card-form-b">
              <p className="labels">CPF *</p>
              <InputMask mask="999.999.999-99" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            </div>
            <div className="card-form-b">
              <p className="labels">Telefone *</p>
              <InputMask mask="(99) 99999-9999" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
            </div>
          </div>

          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Endereço Social (Completo) *</p>
              <InputText value={endereco} onChange={(e) => setEndereco(e.target.value)} />
            </div>
            <div className="card-form-a">
              <p className="labels">Email *</p>
              <InputText value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>

          <div className="card-form">
            <div className="card-form-b">
              <p className="labels">Pessoa com deficiência?</p>
              <Checkbox name="pcd" checked={pcd} onChange={(e) => setPcd(e.checked)} />
            </div>
            <div className="card-form-a" >
              <p className="labels">Necessita de apoio para realização da prova?</p>
              <Checkbox name="apoioEsp" checked={apoioEsp} onChange={(e) => setApoioEsp(e.checked)} /* checked={ingredients.includes('Cheese')} */ />
            </div>
            {
              apoioEsp ?
                <div className="card-form-a">
                  <p className="labels">Qual tipo? *</p>
                  <InputText value={tipoApoio} onChange={(e) => setTipoApoio(e.target.value)} />
                </div>
                : <></>
            }
          </div>

          <br />

          <div className="card-form" >
            <div className="card-form-a">
              <p className="labels">Anexo RG e CPF *</p>
              <span className='input-arquivo'>
                <label className='label-file'
                  style={file_rg_cpf ? { backgroundColor: "#56A54A" } : { backgroundColor: "#475569" }}
                >
                  <span>
                    {file_rg_cpf ?
                      <span>
                        <i className="pi pi-file" ></i>{" "}
                        <span>{file_rg_cpf.name}</span>
                      </span>
                      :
                      <span>
                        <i className="pi pi-times"></i>{" "}
                        <span>Nenhum arquivo selecionado</span>
                      </span>
                    }
                  </span>
                  <input
                    value=""
                    type="file"
                    className='input-files'
                    accept='application/pdf'
                    onChange={e => changeFiles(e.target.files[0], 1)}
                  />
                </label>
              </span>
            </div>

            <div className="card-form-a">
              <p className="labels">Comprovante de Residência *</p>
              <span className='input-arquivo'>
                <label className='label-file'
                  style={file_cr ? { backgroundColor: "#56A54A" } : { backgroundColor: "#475569" }}
                >
                  <span>
                    {file_cr ?
                      <span>
                        <i className="pi pi-file" ></i>{" "}
                        <span>{file_cr.name}</span>
                      </span>
                      :
                      <span>
                        <i className="pi pi-times"></i>{" "}
                        <span>Nenhum arquivo selecionado</span>
                      </span>
                    }
                  </span>
                  <input
                    value=""
                    type="file"
                    className='input-files'
                    accept='application/pdf'
                    onChange={e => changeFiles(e.target.files[0], 3)}
                  />
                </label>
              </span>
            </div>
          </div>

          <div className="card-form">
            <div className="card-form-a">
              <p className="labels">Declaração Pessoal *</p>
              <span className='input-arquivo'>
                <label className='label-file'
                  style={file_decl_pessoal ? { backgroundColor: "#56A54A" } : { backgroundColor: "#475569" }}
                >
                  <span>
                    {file_decl_pessoal ?
                      <span>
                        <i className="pi pi-file" ></i>{" "}
                        <span>{file_decl_pessoal.name}</span>
                      </span>
                      :
                      <span>
                        <i className="pi pi-times" ></i>{" "}
                        <span>Nenhum arquivo selecionado</span>
                      </span>
                    }
                  </span>
                  <input
                    value=""
                    type="file"
                    className='input-files'
                    accept='application/pdf'
                    onChange={e => changeFiles(e.target.files[0], 4)}
                  />
                </label>
              </span>
            </div>
            <div className="card-form-a">
              <p className="labels">Formulário de Autodeclaração (COTAS)</p>
              <span className='input-arquivo'>
                <label className='label-file'
                  style={file_autodeclaracao ? { backgroundColor: "#56A54A" } : { backgroundColor: "#475569" }}
                >
                  <span>
                    {file_autodeclaracao ?
                      <span>
                        <i className="pi pi-file" ></i>{" "}
                        <span>{file_autodeclaracao.name}</span>
                      </span>
                      :
                      <span>
                        <i className="pi pi-times"></i>{" "}
                        <span>Nenhum arquivo selecionado</span>
                      </span>
                    }
                  </span>
                  <input
                    value=""
                    type="file"
                    className='input-files'
                    accept='application/pdf'
                    onChange={e => changeFiles(e.target.files[0], 5)}
                  />
                </label>
              </span>
            </div>
          </div>

          <p className="infos-forms">
            * Campos obrigatórios
          </p>

          <div className="card-rodape">

            <div className="rodape-check">
              <ReCAPTCHA
                sitekey={chaveRecaptcha}
                onChange={(response) => captcharFunction(response)}
                onExpire={() => expira_captcha()}
                language='pt-BR'
              />
            </div>

            <div className="rodape-botao">
              {
                recaptcha ?
                  <Button
                    label="Enviar Dados"
                    icon="pi pi-envelope"
                    className="btn-1"
                    onClick={enviar_email}
                  />
                  :
                  <Button
                    label="Enviar Dados"
                    icon="pi pi-envelope"
                    className="btn-1"
                    disabled
                  />
              }

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default FormBaixoAm;
